import { UserCreateDTO, UserUpdateDTO } from '../models/users';
import apiClient from './api';

export const getUserWithRolesAndModules = async (userID: number) => {
    const response = await apiClient.get(`/user/${userID}`);
    return response.data;
}

export const createUser = async (user: UserCreateDTO) => {
    const response = await apiClient.post('/user', user);
    return response.data;
}

export const createProcurerUser = async (user: UserCreateDTO) => {
    const response = await apiClient.post('/user/procurer', user);
    return response.data;
}

export const generateTwoFactorCode = async (userID: any, notificationType: any) => {
    const response = await apiClient.post(`/user/twoFactor`, {
        UserID: userID,
        NotificationType: notificationType,
        FirstTime: true
    });

    return response.data;
}

export const getUsers = async (organizationID: number | number[], moduleID: number | number[], listIndex: number, searchParam: string, includeDisabled: boolean = false) => {
    let params = new URLSearchParams();

    if (includeDisabled) {
        params.append('includeDisabled', 'true');
    }

    if (Array.isArray(organizationID)) {
        organizationID.forEach(id => params.append('organizationID', id.toString()));
    } else if (organizationID !== undefined) {
        params.append('organizationID', organizationID.toString());
    }

    if (Array.isArray(moduleID)) {
        moduleID.forEach(id => params.append('moduleID', id.toString()));
    } else if (moduleID !== undefined) {
        params.append('moduleID', moduleID.toString());
    }

    params.append('listIndex', listIndex.toString());
    params.append('searchParam', searchParam);

    const response = await apiClient.get('/user', { params });
    return response.data;
}

export const getUsersByDepartment = async (departmentID: number) => {
    const response = await apiClient.get(`/user/department/${departmentID}/list`);
    return response.data;
}

export const getUsersByModule = async (moduleID: number) => {
    const response = await apiClient.get(`/user/module/${moduleID}`);
    return response.data;
}

export const createNewUsersByModule = async (moduleID: number) => {
    const response = await apiClient.post(`/user/module/${moduleID}`);
    return response.data;
}

export const getUserById = async (userID: number) => {
    const response = await apiClient.get(`/user/${userID}`);
    return response.data;
}

export const getUserByEmail = async (email: string, requiredPermission?: string) => {
    let params = new URLSearchParams();

    params.append('email', email);
    if (requiredPermission) params.append('requiredPermission', requiredPermission);

    const response = await apiClient.get(`/user/email`, { params });
    return response.data;
}

export const getManagerUserByTenderID = async (tenderID: number) => {
    const response = await apiClient.get(`/user/manager/${tenderID}`);
    return response.data;
}

export const getUsersByModuleAndRole = async (moduleID: number, roleName: string, userGroupID?: number) => {
    const response = await apiClient.get(`/user/module/${moduleID}/role/${roleName}`, {
        params: userGroupID ? { userGroupID } : undefined
    });
    return response.data;
}

export type RoleOverviewRow = {
    roleName: string;
    moduleID: number;
    moduleName: string;
    userGroupID?: number | null;
    userGroupName?: string | null;
    userID: number;
    firstName?: string | null;
    lastName?: string | null;
    email: string;
    organizationID?: number | null;
    organizationName?: string | null;
}

// Who holds which role, in one call. The server decides the scope: a sysadmin sees every
// organization (optionally filtered), everyone else only their own organization and ramavtal.
export const getRoleOverview = async (moduleIDs: number[], organizationID?: number): Promise<RoleOverviewRow[]> => {
    const params = new URLSearchParams();
    moduleIDs.forEach(id => params.append('moduleID', id.toString()));
    if (organizationID !== undefined) params.append('organizationID', organizationID.toString());

    const response = await apiClient.get('/user/role-overview', { params });
    return response.data;
}

export const updateUser = async (userID: number, user: UserUpdateDTO) => {
    const response = await apiClient.put(`/user/${userID}`, user);
    return response.data;
}

export const requestEmailToken = async (email: string) => {
    const response = await apiClient.post('/user/email-token-request', { email });
    return response.data;
}

export const getAccountRequestToken = async (token: string) => {
    const response = await apiClient.get(`/user/token-account-request/${token}`);
    return response.data;
}

export const resetPasswordRequest = async (email: string, notificationType: number) => {
    const response = await apiClient.post('/user/reset-password', { userEmail: email, notificationType: notificationType }, {responseType:'text'});
    return response.data;
}

export const updatePasswordByToken = async (pw: string, token: string) => {
    const response = await apiClient.put('/user/reset-password', { NewUserPassword: pw, Token: token }, {responseType:'text'});
    return response.data;
}